import { render, staticRenderFns } from "./DefaultResponses.vue?vue&type=template&id=696fb3a2"
import script from "./DefaultResponses.vue?vue&type=script&lang=js"
export * from "./DefaultResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('696fb3a2')) {
      api.createRecord('696fb3a2', component.options)
    } else {
      api.reload('696fb3a2', component.options)
    }
    module.hot.accept("./DefaultResponses.vue?vue&type=template&id=696fb3a2", function () {
      api.rerender('696fb3a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/DefaultResponses.vue"
export default component.exports